{
	"set": "vivid",
	"sourceRef": "../docs/engineering/juice-kit-assets.md#vivid",
	"cue": {
		"id": "stamp.collect",
		"assetId": "vivid.collect",
		"prompt": "bright coin-like chime, two harmonics, quick decay",
		"duration": 0.3,
		"frequencies": [523.25, 784],
		"gain": 0.018,
		"volume": 0.4
	},
	"moments": ["record saved", "daily close committed"],
	"haptic": [10, 40, 20],
	"provider": "local_web_audio",
	"cost": 0,
	"promptSha256": "672213025ff2ae4d4663ecca81d651a665de4132525963a6f9239ffddef95232",
	"planSha256": "6e36d3eb20355bae821612d91a58e32e4fe7b52e6b65c486eeca8dfa45d96ebf"
}
